import { request, unwrap } from '../client';
import type { ApiResponse, SupportSessionRequest, SupportSessionResponse } from '../types';

export const supportSessionsApi = {
  async mint(tenantId: number, req: SupportSessionRequest): Promise<SupportSessionResponse> {
    const res = await request<ApiResponse<SupportSessionResponse>>(
      'POST',
      `/api/saas-admin/tenants/${tenantId}/support-session`,
      { json: req },
    );
    return unwrap(res);
  },
};
